<template>
  <div>
    <!--优惠券-->
<div class="discussCouponList" v-if="paperCoupons.length>0">
  <div class="m_goods_all" v-for="item in paperCoupons">
    <div class="m_goods_list">
      <div class="m_goods_list_content">
        <div class="m_goods_list_pic_contant">
          <img src="item.goodsPic" class="m_goods_list_pic" />
        </div>
        <div class="m_goods_list_content_wrapper">
          <div class="m_googs_content_title">{item.goodsName}</div>
          <div class="m_shop_name">
            <!--img src="../../images/tmallSelected.png" wx:if="{{item.mallType=='天猫'}}" class='tm_icon' />
            <img src="../../images/taobao.png"  wx:if="{{item.mallType!='天猫'}}" class='tm_icon' />
            <img src="../../images/haitao.png"  wx:if="{{item.isHaiTao==1}}" class='tm_icon' />
            <img src="../../images/juhuasuan.png"  wx:if="{{item.isJuHuaSuan==1}}" class='tm_icon' />
            <img src="../../images/taoqianggou.png"  wx:if="{{item.isTaoQiangGou==1}}" class='tm_icon' />
            <img src="../../images/video.png" wx:if="{{item.isVideo==1}}" class='tm_icon'-->
            <img src="../../images/tmallSelected.png"  class='tm_icon' />
            {item.shopName}</div>
        </div>
      </div>
      <div class="m_goods_list_price">
        <div class="m_goods_conut">
          <div class="m_goods_conut_in">
            <span class="mt1">￥</span>100
          </div>
          <div class='m_goods_conut_btn'>去领券</div>
        </div>
      </div>
      <div class="m_circle_line">
        <div class="m_circle1"></div>
        <div class="m_line"></div>
        <div class="m_circle2"></div>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script type = "text/ecamscript-6">
  import {getDateDiff,config} from  '../../common/js/common.js'
  export default {
    name:"paperCoupons",
    props:['paperid'],
    data(){
      return{
       paperCoupons:[],
       page:1,
       pageSize:10,
       globalUrl : config.gobalUrl
      }
    },
    methods:{
      login () {

        this.url = "api/getDiscussCoupons.php?page="+this.page+"&pageSize="+this.pageSize+"&paperid="+this.paperid
        console.log(this.url)
        this.$ajax.autoService
            .login(this.url)
            .then((res) => {
              this.paperCoupons = this.paperCoupons.concat(res.data.map(function (item) {
              //item.createtime = getDateDiff(new Date(item.createtime.replace(/-/g, '/')));
              // if (item.picUrls && item.picUrls != '') {
              //   item.pics = item.picUrls.split(',')
              // }
              //item.menuOpen = false
              return item
            }));
            // this.paperWelfares = this.paperWelfares[0]
            // console.log(this.papers)
              this.$nextTick(() => {
                this.REQUIRE = true;
                this.loading = false;
              });
            }, (res) => {
                console.log("error")
                this.REQUIRE = true;
            })
       },
    }
  }


</script>
<style  lang="stylus">
  .m_goods_all
    width: 100%
    background: #f5f5f5
    padding:25px  20px
    box-sizing: border-box
    margin-top: 20px
    border-radius: 15px
    height: 190px
    position: relative
    .m_goods_list
      display: flex
      width: 100%
      .m_goods_list_content
        flex: 1
        display: flex
        .m_goods_list_pic_contant
          flex: 0 0 140px
          .m_goods_list_pic
            width: 140px
            height: 140px
            border-radius: 100px
        .m_goods_list_content_wrapper
          flex: 1
          padding-left: 20px
          display: flex
          justify-content: space-between
          flex-direction: column
          height: 140px
          .m_googs_content_title
            width: 260px
            font-size: 24px
            height: 80px
            color: #000;
            overflow: hidden
            text-overflow: ellipsis
            display: -webkit-box
            -webkit-line-clamp: 2
            -webkit-box-orient: vertical
            line-height: 40px
            padding-top: 5px
          .m_shop_name
            font-size: 20px
            color: #999
            .tm_icon
              width:30px
              height:30px
              vertical-align: middle
              margin: 5px
      .m_goods_list_price
        flex: 0 0 194px
        position: relative
        .m_goods_conut
          position: absolute
          left: 50%
          top: 50%
          transform: translate(-50%,-50%)
          margin-left: 10px
          .m_goods_conut_in
            color: #ff4400
            text-align: center
            font-size: 36px
            font-weight: bold
            .mt1
              font-size:24px
          .m_goods_conut_btn
            width: 130px
            height: 50px
            color: #f5f5f5
            text-align: center
            line-height: 50px
            font-size: 24px
            background: #f40
            border-radius: 25px
      .m_circle_line
        position: absolute
        width: 24px
        height: 100%
        right: 194px
        top: 0px
        .m_circle1
          width: 24px
          height: 12px
          background: #fff
          border-radius: 0 0 12px 12px
          top: 0px
          left: 0px
          position: absolute
        .m_circle2
          width: 24px
          height: 12px
          background: #fff
          border-radius: 12px 12px 0 0
          bottom: 0px
          left: 0px;
          position: absolute
        .m_line
          border-left: 1px dotted #dddddd
          /*px*/
          height: 100%
          margin: 0 auto
          width: 0px
  </style>



// WEBPACK FOOTER //
// src/components/quan/paperCoupons.vue